import { render, staticRenderFns } from "./sp-number.vue?vue&type=template&id=97679354"
import script from "./sp-number.vue?vue&type=script&lang=js"
export * from "./sp-number.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports